import { createStandaloneToast, UseToastOptions } from "@chakra-ui/react";

const { ToastContainer, toast } = createStandaloneToast({
  defaultOptions: {
    position: "top",
    duration: 3000,
    isClosable: true,
  },
});

export { ToastContainer, toast };

export const Toast = (options: UseToastOptions = {}) =>
  toast({
    position: "top",
    duration: 3000,
    isClosable: true,
    ...options,
  });
